import { makeAutoObservable } from "mobx";

export class AppStore {
    showLoginNotice = false;
    constructor() {
        makeAutoObservable(this);
    }

    setShowLoginNotice(show: boolean) {
        this.showLoginNotice = show;
    }
}
